enum ChartType {
  ENGAGEMENT = "engagement",
  SOURCE = "source",
}

export default ChartType;
